import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const ShootingStar = () => {
    const [shouldAnimate, setShouldAnimate] = useState(true);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        setShouldAnimate(!mediaQuery.matches);
        const handleChange = (e) => setShouldAnimate(!e.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    if (!shouldAnimate) return null;

    return (
        <motion.div
            className="fixed inset-0 pointer-events-none z-1"
            initial={{ opacity: 0 }}
            animate={{
                opacity: [0, 1, 1, 0],
                x: ['0vw', '120vw'],
                y: ['60vh', '20vh'],
            }}
            transition={{
                duration: 2.5,
                ease: [0.445, 0.05, 0.55, 0.95], // Custom easing for smoother arc
                repeat: Infinity,
                repeatDelay: 15
            }}
        >
            {/* Star */}
            <div className="relative w-6 h-6">
                <div
                    className="w-full h-full"
                    style={{
                        background: 'linear-gradient(45deg, #FFD700, #FFF)',
                        clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)'
                    }}
                />
            </div>

            {/* Trail */}
            <div className="absolute w-48 h-px top-3 -right-48 bg-gradient-to-l from-transparent via-yellow-200/40 to-transparent" />

            {/* Stardust */}
            <div className="absolute right-6 top-3">
                {[...Array(12)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-1 h-1 rounded-full bg-yellow-200/60"
                        initial={{ x: 0, y: 0, opacity: 1 }}
                        animate={{
                            x: -30 - (Math.random() * 20),
                            y: -5 + (Math.random() * 10),
                            opacity: 0
                        }}
                        transition={{
                            duration: 1,
                            repeat: Infinity,
                            delay: i * 0.08,
                            ease: "linear"
                        }}
                    />
                ))}
            </div>
        </motion.div>
    );
};

export default ShootingStar;
